import theme from '@styles/theme';
export default {
  features: (isListing = false) => ({
    position: 'relative',
    mt: isListing ? 40 : ['42px', '64px', '80px', '80px']
  }),
  container: (rows = true, isListing = false) => ({
    display: 'flex',
    flexFlow: rows ? ['column wrap', 'row wrap', 'row wrap', 'row wrap'] : 'column wrap',
    borderBottom: `1px solid ${theme.rawColors.lightGrey700}`,
    width: isListing ? 'fit-content' : '100%',
    pb: '16px'
  }),
  feature: (isListing = false, order?: number) => ({
    width: isListing ? '100%' : ['100%', '50%', '50%', '50%'],
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    color: theme.rawColors.darkGrey700,
    alignItems: 'center',
    fontSize: isListing ? theme.fontSizes.smallText : [theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.text],
    order: order || 1,
    mt: '16px',
    '&:first-of-type': {
      mt: 0
    },
    '&:nth-of-type(2)': {
      mt: isListing ? '16px' : ['16px', 0, 0, 0]
    },
    'span:first-of-type': {
      mr: '8px'
    }
  }),
  surface: {
    mt: 16
  }
};